import kbpgp from 'kbpgp'
import { promiseify } from '~/helpers'


const { import_from_armored_pgp: importFromArmoredPgp } = kbpgp.KeyManager
const { box } = kbpgp

const encryptParams = promiseify(box)
const createKeyManager = promiseify(importFromArmoredPgp)

const serializePayload = payload =>
  Object.entries(payload)
    .map(a => a.join('='))
    .join(',')

export default async (payload, armored) => {
  const msg = serializePayload(payload)
  const keyManager = await createKeyManager({ armored })
  const params = { msg, encrypt_for: keyManager }
  return encryptParams(params)
}
